<template>
  <div>
    <Head title="會員中心 - 變更密碼" />
    <user-template title="會員中心">
      <template #header>變更密碼</template>

      <main>
        <div class="form">
          <div class="form-title">現有密碼</div>
          <div class="form-element">
            <Password
              v-model="password.old"
              :class="{ 'p-invalid': $page.props.errors.old }"
              :toggleMask="true"
              :feedback="false"
            />
          </div>
          <div v-if="$page.props.errors.old" class="error_information">
            {{ $page.props.errors.old }}
          </div>
        </div>
        <div class="form">
          <div class="form-title">新密碼</div>
          <div class="form-element">
            <Password
              v-model="password.new"
              :class="{ 'p-invalid': $page.props.errors.new }"
              toggleMask
              promptLabel="請輸入您的密碼"
              weakLabel="弱"
              mediumLabel="一般"
              strongLabel="強"
            />
          </div>
          <div v-if="$page.props.errors.new" class="error_information">
            {{ $page.props.errors.new }}
          </div>
        </div>
        <div class="form">
          <div class="form-title">新密碼確認</div>
          <div class="form-element">
            <Password v-model="password.new_confirmation" :feedback="false" />
          </div>
        </div>
        <div class="pt-10 w-full text-right">
          <Button label="儲存變更" @click="changePassword" />
        </div>
      </main>
    </user-template>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import UserTemplate from "./Shared/UserTemplate";
import Password from "primevue/password";
import Button from "primevue/button";
export default {
  components: {
    UserTemplate,
    Password,
    Button,
  },
  layout: Layout,
  data() {
    return {
      password: {
        old: null,
        new: null,
        new_confirmation: null,
      },
    };
  },
  methods: {
    changePassword() {
      this.$inertia.post(route("user.profile.change_password"), this.password, {
        only: ["errors", "flash"],
        preserveState: true,
        preserveScroll: true,
      });
    },
  },
};
</script>

<style lang="postcss">
/*  */
</style>